import { ENotificationType } from '../enums/notifications/ENotificationType';
import { INotifications } from '../interfaces/notifications/INotifications';

export const getNotificationValue = (notification: INotifications) => {
  if (
    notification.notificationType ===
    ENotificationType.VACATION_REQUEST_RESPONSE
  ) {
    return notification?.leaveDays?.status;
  }
  if (
    notification.notificationType ===
    ENotificationType.ASSIGNED_TO_NEW_DEPARTMENT
  ) {
    return notification?.department?.name;
  }
  if (
    [
      ENotificationType.PROJECT_CANCELED,
      ENotificationType.PROJECT_FINISHED,
      ENotificationType.ASSIGNED_TO_NEW_PROJECT,
      ENotificationType.NEW_USER_TO_PROJECT,
      ENotificationType.REMOVED_FROM_PROJECT,
    ].includes(notification.notificationType)
  ) {
    return notification?.project?.name;
  }
};
